import React from "react";
import { Hero } from "../components/sections/Hero";
import { Seo } from "../components/Seo";
import { ClientLogos } from "../components/sections/ClientLogos";
import { ServicesOverview } from "../components/sections/ServicesOverview";
import { HowItWorksOverview } from "../components/sections/HowItWorksOverview";
import { RevenueCalculator } from "../components/sections/RevenueCalculator";
import { CTASection } from "../components/sections/CTASection";
import { Band } from "../components/Band";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Seo k="home" />
      <Hero />
      <Band tone="dark"><ServicesOverview /></Band>
      <Band tone="light"><HowItWorksOverview /></Band>
      <Band tone="dark"><RevenueCalculator /></Band>
      <Band tone="light"><CTASection /></Band>
      <Band tone="dark"><ClientLogos /></Band>
    </main>
  );
}
